import React, { useEffect, useState } from "react";
import {
  View,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  Dimensions,
  Keyboard,
  Pressable,
  TouchableWithoutFeedback,
} from "react-native";
import { isTablet } from "react-native-device-info";

interface KeyboardScrollWrapperProps {
  children: React.ReactNode;
  keyboardOffset?: number;
  containerStyle?: object;
  scrollViewStyle?: object;
}

const KeyboardScrollWrapper: React.FC<KeyboardScrollWrapperProps> = ({
  children,
  keyboardOffset = Platform.OS === "ios" ? 0 : 20, // slightly higher offset helps
  containerStyle = {},
  scrollViewStyle = {},
}) => {
  const [isPortrait, setIsPortrait] = useState(
    Dimensions.get("window").height >= Dimensions.get("window").width
  );

  useEffect(() => {
    const handleOrientationChange = () => {
      const { width, height } = Dimensions.get("window");
      setIsPortrait(height >= width);
    };
    const subscription = Dimensions.addEventListener(
      "change",
      handleOrientationChange
    );
    return () => subscription?.remove();
  }, []);

  const defaultContainerStyle = {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: isTablet()?isPortrait ? 20 : 40:null,
    paddingVertical: isTablet()?isPortrait ? 30 : 20:null,
    flexDirection: isPortrait ? "column" : "row",
  };

  const defaultScrollViewStyle = {
    flexGrow: 1,
    width: "100%",
  };

  if (Platform.OS === "android") {
    return (
      <ScrollView
        contentContainerStyle={[defaultScrollViewStyle, scrollViewStyle]}
        showsVerticalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
      >
        <View style={[defaultContainerStyle, containerStyle]}>{children}</View>
      </ScrollView>
    );
  }

  const FormContainer =
    Platform.OS !== "web" ? Pressable : TouchableWithoutFeedback;

  return (
    <KeyboardAvoidingView
      style={{ flex: 1 }}
      behavior="padding"
      keyboardVerticalOffset={keyboardOffset}
    >
      <FormContainer
        onPress={() => {
          if (Platform.OS !== "web") Keyboard.dismiss();
        }}
        style={{ flex: 1 }}
      >
        <ScrollView
          contentContainerStyle={[defaultContainerStyle, scrollViewStyle]}
          showsVerticalScrollIndicator={false}
          keyboardShouldPersistTaps="handled"
        >
          {children}
        </ScrollView>
      </FormContainer>
    </KeyboardAvoidingView>
  );
};

export default KeyboardScrollWrapper;
